import NavigationView from './NavigationViewContainer';
export default NavigationView;
